import CheckCircle from '@mdi/svg/svg/check-circle.svg?react';
import {
  Button,
  Flex,
  MDIIcon,
  PopoverTooltip,
  usePopoverTooltip,
} from '@solinkcorp/solink-components';
import React from 'react';
import styles from './SaveDetails.styles';

interface SharedEmailProps {
  accessStatusClass: string;
  accessStatusTooltip: string;
  recipientClass: string;
  shareEmail: string;
}
const SharedEmail: React.FC<SharedEmailProps> = (props) => {
  const { accessStatusClass, accessStatusTooltip, recipientClass, shareEmail } = props;

  const popover = usePopoverTooltip({ placement: 'top' });

  return (
    <div className={recipientClass} ref={popover.setTriggerRef}>
      <Flex alignItems="center" className="wrap">
        <Button
          className={accessStatusClass}
          icon={
            <Flex style={styles.recipientIconButton}>
              <MDIIcon icon={CheckCircle} />
            </Flex>
          }
          iconOnly={true}
          style={styles.recipientIconButton}
          type="clear"
        />
        <span className="email-body">{shareEmail}</span>
      </Flex>
      <PopoverTooltip {...popover}>{accessStatusTooltip}</PopoverTooltip>
    </div>
  );
};

export default SharedEmail;
